export default __webpack_public_path__ + "static/media/DtVhJx26TKEr37c9aBB5iXwJxArepzhN.56a68f7f.woff2";